"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CronosOracleRegistryFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_timeout",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        inputs: [],
        name: "RESPONSE_DECIMALS",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "_token",
                type: "address",
            },
        ],
        name: "addStablecoin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "_token",
                type: "address",
            },
        ],
        name: "getPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "_token",
                type: "address",
            },
            {
                internalType: "contract ICronosOracle",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "registerOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "_token",
                type: "address",
            },
        ],
        name: "removeOracle",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "_token",
                type: "address",
            },
        ],
        name: "removeStableCoin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "",
                type: "address",
            },
        ],
        name: "stablecoins",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timeout",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ERC20",
                name: "",
                type: "address",
            },
        ],
        name: "tokenToOracle",
        outputs: [
            {
                internalType: "contract ICronosOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class CronosOracleRegistryFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_timeout, overrides) {
        return super.deploy(_timeout, overrides || {});
    }
    getDeployTransaction(_timeout, overrides) {
        return super.getDeployTransaction(_timeout, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.CronosOracleRegistryFactory = CronosOracleRegistryFactory;
CronosOracleRegistryFactory.bytecode = _bytecode;
CronosOracleRegistryFactory.abi = _abi;
//# sourceMappingURL=CronosOracleRegistryFactory.js.map